import React, {Suspense} from 'react';
import { useTranslation } from 'react-i18next';
import {Route, Switch, useRouteMatch} from "react-router-dom";
import UsersList from "../../pages/difacto/organisation/users/Users";
import User from "../../pages/difacto/organisation/users/User";
import NewUser from "../../pages/difacto/organisation/users/NewUser";
import EditUser from "../../pages/difacto/organisation/users/EditUser";

function Users(props) {
  const { path } = useRouteMatch();
	const { t } = useTranslation();

	return (
    <Suspense fallback={<div>{t('loading')}...</div>}>
      <Switch>
        <Route exact path={path} component={UsersList}/>
        <Route exact path={`${path}/new`} component={NewUser}/>
        <Route path={`${path}/:userId/edit`} component={EditUser}/>
        <Route path={`${path}/:userId`} component={User}/>
      </Switch>
    </Suspense>
	)
}

export default Users
